export default {
  // 登录
  login: {
    mobile: '手机登录',
    email: '邮箱登录',
    EnterpriseWeChat: '企业微信',
    PersonalWechat: '微信',
    way: '其他方式',
    login: '登录',
    register: '注册',
    confirm: '确定',
    tip: '请使用企业微信扫码登录',
    mobilePassWord: '账号登录',
    mobileCodePassWord: '手机登录',
    wechatScan:'微信扫码登录',
    CodePassWord: '密码登录',
    emailPassWord: '邮箱密码登录',
    mobilePlaceholder: '请输入手机号',
    mobileEmailPlaceholder: '请输入手机号/邮箱',
    mobileLegitimatePlaceholder: '请输入合法的手机号',
    emailFormat: '请输入正确的邮箱格式',
    passWordPlaceholder: '请输入密码',
    againPassWordPlaceholder: '请再次输入密码',
    emailPlaceholder: '请输入邮箱',
    codeWordPlaceholder: '请输入验证码',
    company: '请输入公司名称',
    getCode: '获取验证码',
    protocol1: '我已阅读并同意',
    protocol2: '《速境科技用户服务协议》',
    goRegister1: '没有账号，',
    goRegister2: '去注册',
    goLogin1: '已有账号，',
    goLogin2: '去登录',
    passWordLogin: '密码登录',
    codepPassWordLogin: '手机登录',
    mobileRegister: '手机号注册',
    reacquire: '重新获取',
    successLogin: '登录成功',
    failLogin: '登录失败',
    sendCodeSuccess: '发送验证码成功',
    getCodeFail: '获取验证码失败',
    qccodeExpired: '二维码已过期，点击',
    refresh: '刷新',
    scanCodeSuccess: '扫码成功',
    scanCodeFail: '扫码失败',
    cancelLogin: '您已取消此次登录，可再次扫码登录',
    getUserInfoFail: '获取用户信息失败!',
    getQrcodeFail: '获取二维码失败',
    PleaseSetPassword: '请设置登录密码：',
    PasswordMatch: '两次输入密码不一致',
    selectSystem: '我的导航',
    noSelectSystem: '产品推荐',
    system: '系统',
    copyright: 'Copyright © 2022-2022 SIJIN All Rights Reserved. 上海速境科技有限公司'
  },
  // 协议
  agreement: {
    p1: '速境科技用户服务协议',
    p2: '协议构成及须知',
    p3: '1. 欢迎使用由上海速境科技有限公司（以下简称“速境科技”或“我们”）合法拥有并运营的速境科技产品及服务。',
    p4: '2. 速境科技的产品包括各版本客户端应用程序、小程序以及域名为geekyum.com的网站。速境科技相关网站、服务、产品、应用程序与内容，在《速境科技用户服务协议》（以下简称“本协议”）中统称为“本服务”。个人用户及个人用户所代表的企业统称为“您”。',
    p5: '3. 本协议为您与我们之间的有效协议，规定了您注册、登录、使用（统称“使用”）本服务时须遵循的条款与条件。您使用本服务即表示您确认您具备履行本协议的完整的民事权利能力和民事行为能力；否则，您不应使用本服务。对本服务的使用行将被视为对本协议条款的完全接受，包括接受我们对条款所做的任何修改。',
    p6: '4. 请您在使用本服务之前，仔细阅读并充分理解本协议。本协议的免除或者限制责任条款等重要内容将以加粗形式提示您注意。',
    p7: '用户使用规范',
    p8: '1. 您应正确配置和使用本服务，并自行采取一定的安全性措施，对您的内容进行保护。',
    p9: '2. 本服务仅基于正常和合法的商业用途向您提供。当使用本服务时，您不得：',
    p10: '1）将本服务用于违法行为；',
    p11: '2）以任何形式将本服务再授权、出售或转让给其他第三方；',
    p12: '3）向我们提供虚假、或可能具有误导性、欺诈性欺骗性的公司或个人信息；',
    p13: '4）发送任何未经我们或接收方同意的广告、招揽推广材料、“垃圾邮件”、“垃圾短信”、“连锁信”、“传销”或任何其它被禁止的招揽形式内容；',
    p14: '5）盗用、破坏、攻击或窃取网络数据；',
    p15: '6）其他可能损害我们连续服务或者商誉的行为。',
    p16: '如果您使用本服务从事上述行为，我们有权在不事先通知您的情况下，自行决定采取适当的处置措施，包括但不限于预警、限制、暂停和终止您对整个服务的使用 或部分服务，对全部或部分账户功能进行禁令，冻结或永久删除账户并终止本条款，由此产生的任何后果和损失由您自行承担。',
    p17: '3. 我们使用您在注册时提供的互联网域名对应的电子邮件地址作为您的唯一身份识别信息。当您不再有权使用该邮箱或域名时，我们有权随时删除该邮箱或域名对应账户下的所有数据。',
    p18: '4. 您必须自行配备上网和使用电信增值业务所需的设备，自行负担上网或第三方（包括但不限于电信或移动通信提供商）收取的通讯费、信息费等有关费用。如涉及电信增值服务的，请与您的电信增值服务提供商确认相关的费用问题。',
    p19: '知识产权',
    p20: '1. 您了解并同意，除非我们另有说明或相关权利人依照法律规定享有权利，否则本服务包含的产品、技术、软件、程序、数据及其他所有信息内容，包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等（简称“速境科技内容”）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利均归我们或我们的关联公司所有。未经我们或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、转载、散布、传播、播放、展示、出售、许可、镜像、上载、下载本服务中的内容）。',
    p21: '2. 您完全拥有在使用本服务时创建的数据和资料（包括但不限于：货物资料、价格数据、客户资料、联系人等信息）的所有权，并有权进行任何形式的处置，包括从本服务中国复制、导出和删除。',
    p22: '3. 您不得将涉及我们拥有知识产权的相关内容用于本协议范围以外的任何商业目的或泄露给第三方。您不得出售、转售或复制本服务内容，亦不可基于商业目的模仿我们的产品和服务。您不可复制和模仿我们的设计理念、界面、功能和文字及图形说明。未经我们许可，您不得基于此协议所约定的服务对本服务的内容进行修改或制造、衍生其它产品。',
    p23: '数据安全及保密',
    p24: '1. 数据备份：在近实时备份之上，我们保证每天数据完整备份至少一次，增量备份至少三次。月备份保留一年，日备份保留一周，增量备份保留一天。我们每天都对用户储存在我们服务器上的数据信息进行异地备份，做好冗灾预防机制，以确保在系统发生问题后，可以快速恢复系统正常运行。',
    p25: '2. 您有义务维护自己在本服务中的账户信息的完整性、密码的保密性。因您维护或保密不善致使相关信息泄露，或由于第三方盗用用户帐号和密码进行各种操作而造成的损失，由您自行负责。您不得向他人提供本服务的全部或部分内容，也不得容许他人通过您的账户使用本服务。',
    p26: '3. 我们不接受您口头要求重设密码的指令。我们不知道您在初始化后设置的密码。我们不会采取任何侵犯隐私的行动。',
    p27: '4. 您对输入数据的准确性、可靠性、合法性和适用性负全部责任。 您不得违反我们的安全或授权措施，不得读取或访问不属于您的数据。',
    p28: '5. 本条款中的保密义务、权利和责任不适用于以下情况：',
    p29: '1）非因我们的不当原因而为公众所知悉的信息；',
    p30: '2）通过其他不受保密义务限制的渠道获得的信息；',
    p31: '3）经用户授权发布的信息；',
    p32: '4）应法律、法院或国家其他主管部门要求披露的信息。',
    p33: '6. 我们保留使用匿名且非特定用户的汇总统计数据的权利。',
    p34: '7.我们保留向您推送广告的权利，这些广告的加载过程可能会应用必要的定向技术来提高相关性。但我们不会将您的任何私人信息透露给广告商，仅通过应用匿名自动匹配技术实现高度相关性。',
    p35: '服务水平及赔偿',
    p36: '1. 我们将尽最大努力确保持续可靠的服务，我们将提前一周通知您任何计划的停机升级或维护。此停机时间不计入正常运行时间可用性的百分比。如果您对升级维护停机有不同意见，需要在收到通知后的次日内提出申请并与我们协商。',
    p37: '2. 我们将尽最大努力确保您数据的安全备份。我们承诺当服务器存储设备损坏任何数据时，尽快从最新备份中恢复数据。但是，我们不保证100%的数据恢复。对于因数据丢失而造成的其他连带或间接损失，我们不承担任何责任。',
    p38: '3. 在发生需要从备份文件中恢复数据的情形时，我们通常需要4至48小时来完成，在此时间范围内的数据恢复视作服务是连续的。',
    p39: '不可抗力及免责条款',
    p40: '1. 因一切不可控因素引起的服务中断和长时间终止不属于我们违约，我们将不承担赔偿责任。不可控因素包括但不限于：',
    p41: '1）您的客户终端硬件及网络，互联网络，机房供电系统故障；',
    p42: '2）不可抗力：地震、台风、洪水等自然灾害；战争、罢工、停电、政府行为等；政府电力部门或电信部门的行为；电信线路被人为破坏或骨干网线路、设备因调试、扩容所引起的中断；INTERNET公网阻塞或其他通路（如访问目的地的服务器响应速度）问题；外部人为破坏因素引起的，超过安全设备的承载能力。',
    p43: '3）其它不可预见、不可避免、不可克服和不可控制的不可抗力。遭受不可抗力的一方应采取一切必要措施减少损失，并在事件消除后协商恢复本合同的履行。',
    p44: '2. 我们不保证本服务所载公开信息、软件演示和免费软件服务内容的准确性、可靠性或完整性，并明确地否认就该等信息和软件功能的错误或遗漏承担责任；并不对信息和免费软件做出任何种类的保证，包括（但不限于）有关没有侵犯第三方权利、所有权、适销性、质量令人满意、适合特定的用途和没有计算机病毒的保证。',
    p45: '3. 我们对任何损害概不负责，无论这些损害是否由于使用、不能使用本服务的结果或由连到本服务的任何Web网站或者任何这类网站中包含的信息所引起（包括但不限于由损失的利润、损失的数据或业务中断而造成的损害），也不管它们是否有保证、合同、侵权行为或任何其它法律根据以及事前已得到这类损害可能发生的消息。如果您由于使用本站的免费信息和免费软件版本导致需要对设备或数据进行维护、修理或纠正，您须承担由此而造成的所有费用。',
    p46: '4. 在任何情况下，我们对于与使用或未能使用本服务或任何链接的网站免费的内容、资料、软件功能有关任何直接的、间接的、特殊的、连带的或其它损失（包括但不限于任何利润损失、业务中断以及您的信息处理系统中的信息或程序或其它数据的丢失）不向任何机构承担责任。',
    p47: '5.本服务中论坛、博客中的所有言论并不代表我们的观点。这里所指的言论包括新闻及动态但不仅限于此。如果上面的言论对您造成伤害，我们将协助您及有关部门依据相关法律法规清除相关内容并查找IP记录，但我们承担任何责任。',
    p48: '条款修订',
    p49: '我们有权随时对本协议的条款进行修订，并在修订生效日前三个工作日更新在本服务中。',
    p50: '争议解决',
    p51: '1. 本协议适用中华人民共和国法律，签署地为中国上海市。',
    p52: '2. 如果就本协议的解释或执行发生争议，双方应首先力争通过友好协商解决该争议。如果在一方向其他方送达要求开始协商的书面通知后六十天内未能通过协商解决争议，那么任何一方均可将争议提交至上海国际仲裁中心，按照其届时有效的规则进行仲裁。仲裁裁决是终局的，对各方均有约束力，不可上诉。仲裁费用由败诉方承担，除非仲裁裁决另有规定。当任何争议发生时以及在对任何争议进行仲裁时，除争议事项外，各方应继续行使各自在本协议项下的其他权利，履行各自在本协议项下的其他义务。'
  }
}
